import lazySizes from "lazysizes";


window.loadScript = function (id) {
	window.dependencies.state[id] = window.dependencies.state[id] ||
		new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = window.dependencies.libraries[id];
			script.onerror = reject;
			script.onload = resolve;
			document.body.appendChild(script);
		})
			.catch(() => console.error(`Could not load dependency: ${id}`));
	return window.dependencies.state[id];
}

document.addEventListener('lazybeforeunveil', (event) => {
	if (event.detail.instance !== lazySizes) return;
	if (!event.target.hasAttribute('data-module')) return;
	const dependencies = event.target.dataset.dependencies;
	if (!dependencies) {
		event.target.dataset.module = 'ready';
		document.dispatchEvent(new Event('dependency-chain:loaded'));
		return;
	}

	const groups = dependencies.split('|').map(g => g.split(','));
	const loadGroups = async () => {
		for (const group of groups) {
			await Promise.all(group.map(d => d.trim()).map(window.loadScript))
		}
	}
	loadGroups().finally(() => {
		event.target.dataset.module = 'ready';
		document.dispatchEvent(new Event('dependency-chain:loaded'));
	});
});


document.addEventListener('alpine:init', () => {
	if (!Array.isArray(window.dependencies.alpineData)) {
		return;
	}
	// window.dependencies.alpineData.forEach(d => {
	// 	d.data = Alpine.reactive(d.data);
	// 	Alpine.data(d.name, () => (d.data));
	// });
	window.dependencies.alpineData.forEach(d => {
		const data = {
			properties: [],
			regions: [],
			change: 0,
			init() {
				this.$watch('change', async () => {
					await this.$nextTick();
					document.dispatchEvent(new Event(`${d.name}:nextTick`));
				});
			}
		}
		d.data = Alpine.reactive(data);
		Alpine.data(d.name, () => (d.data));





		// d.data.init = function () {
		// 	console.log('init');
		// 	this.$watch('properties', async () => {
		// 		await this.$nextTick();
		// 		document.dispatchEvent(new Event(`${d.name}:nextTick`));
		// 		console.log('in body');
		// 	});
		// }
		// d.data = Alpine.reactive(d.data);
		// Alpine.data(d.name, () => (d.data));
	});
	// window.dependencies.alpineData.map(d => {
	// 	d.data = Alpine.reactive(d.data);
	// 	return Alpine.data(d.name, () => ({
	// 		data: d.data,
	// 		init() {
	// 			this.$watch('data', async () => {
	// 				await this.$nextTick();
	// 				document.dispatchEvent(new Event(`${d.name}:nextTick`));
	// 			});
	// 		}
	// 	}))
	// });
});


document.addEventListener('propertiesListingWithMapElement:nextTick', () => {
	console.log('next tick here');
});
